import React, { useState, useEffect } from "react";
import { Grid,FileInput,Box,Button } from "grommet";
import {withRouter} from 'react-router-dom'
import { API,Auth } from 'aws-amplify';
import ShipmentBillingTable from "./shipmentBillingTable";
import Papa from "papaparse";

function ListBillingShipments(props) {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [shipments, setShipments] = useState("");
  const [invoiceFile, setInvoiceFile] = useState("");
  function fetchShipments(params){
    Auth.currentSession().then(session => {
      API
        .get("LabShip", '/shipments_billing_index',{headers: { 
          Authorization: session.idToken.jwtToken,
        }})
        .then(
          (result) => {
            setShipments(result.shipments);
            setDataLoaded(true);
          },
          (error) => {
            console.log(error);
          }
        );
    })
  }
  useEffect(() => {
   fetchShipments(null)
  }, []);

  function submitInvoice(){
    setDataLoaded(false)
    Papa.parse(invoiceFile, {
      complete: function(results) {
        var csvString = Papa.unparse(results)
        Auth.currentSession().then(session => {
          API
            .post("LabShip", '/shipments_billing',{headers: { 
              Authorization: session.idToken.jwtToken,
            },
            body:{data: csvString}
          })
            .then(
              (result) => {
                setShipments(result.shipments);
                setDataLoaded(true);
              },
              (error) => {
                console.log(error);
              }
            );
        })
      }
    });
   
  }
  

  return (
    <Grid>
      <Box alignSelf="end"><Box direction="row" margin={{top:'small'}} width='large' alignSelf="end"><FileInput width={'small'} onChange={(event, { files }) => { const fileList = files; for (let i = 0; i < fileList.length; i += 1) {setInvoiceFile(fileList[i]);}}} /><Button onClick={submitInvoice} type='submit' primary hoverIndicator margin={{left: 'small'}} label='Submit' /></Box></Box>
      <ShipmentBillingTable props={props} dataLoaded={dataLoaded} shipments={shipments} />
    </Grid>
  )
              
}

export default withRouter(ListBillingShipments);
